import { Profile, ProfileUpdate } from 'src/app/models/profile.model';

export class LoadProfile {
  static readonly type = '[Profile] Load';
}

export class LoadProfileSuccess {
  static readonly type = '[Profile] Load Success';
  constructor(public profile: Profile) {}
}

export class LoadProfileFail {
  static readonly type = '[Profile] Load Fail';
  constructor(public error: string) {}
}

export class UpdateProfile {
  static readonly type = '[Profile] Update';
  constructor(public update: ProfileUpdate) {}
}

export class UpdateProfileSuccess {
  static readonly type = '[Profile] Update Success';
  constructor(public message: string) {}
}

export class UpdateProfileFail {
  static readonly type = '[Profile] Update Fail';
  constructor(public error: string) {}
}
